/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mk_Shot_ExpandInputs */

const en_mk_shot_expand = /** @type {(inputs: Mk_Shot_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enlarge screenshot: ${i?.name}`)
};

const id_mk_shot_expand = /** @type {(inputs: Mk_Shot_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perbesar screenshot: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Enlarge screenshot: {name}" |
*
* @param {Mk_Shot_ExpandInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_expand = /** @type {((inputs: Mk_Shot_ExpandInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_ExpandInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_expand(inputs)
	return en_mk_shot_expand(inputs)
});